import type { PersonDto } from "./api/client";

/** The server retains the real attendees; the shared column displays their event once. */
export function calendarPersonIds(ids: readonly string[], persons: readonly PersonDto[]): string[] {
  const group = persons.find((p) => p.isActive && p.isEveryone && ids.includes(p.id));
  return group ? [group.id] : [...new Set(ids)];
}
